import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ResultPageModel } from '../../Core/SortingAndPaging/Models/ResultPageModel';
import { ExternalAsset } from '../../Models/Domains/Investment/ExternalAsset';
import { ExternalAssetsQuery } from '../../Models/Domains/Investment/ExternalAssetsQuery';

declare var IS_RUNNING_IN_APP_POOL;

export class ExternalAssetsSearchClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(query: ExternalAssetsQuery, hierarchyId: string): Promise<ResultPageModel<ExternalAsset>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruments/ExternalAssetsSearch/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { query: query, hierarchyId: hierarchyId }

    return AjaxWrapper.post<ResultPageModel<ExternalAsset>, any>(url, data);
  }
}

